function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "php",
  d: "M1883.6,470.9h-111.3l-42.8,256.9h0h102.7c77.1-8.6,145.5-34.2,154.1-179.8 C1986.3,496.6,1943.5,470.9,1883.6,470.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "php",
  d: "M736.3,470.9H625l-42.8,256.9l0,0h102.7c77.1-8.6,145.5-34.2,154.1-179.8C839,496.6,796.2,470.9,736.3,470.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "php",
  d: "M1250,0C559.6,0,0,291.3,0,650.7s559.6,650.7,1250,650.7S2500,1010,2500,650.7S1940.4,0,1250,0z M702,856.2 H547.9L513.7,1036H351l137-693.5h316.8c137,8.6,205.5,77.1,205.5,196.9C1010.3,744.9,847.6,864.7,702,856.2z M1346.6,470.9h-128.4 l-77.1,385.3H978.4l137-693.5h162.7l-34.2,179.8h154.1c137,8.6,188.4,77.1,171.2,162.7l-59.9,351H1338l59.9-316.8 C1406.5,496.6,1406.5,470.9,1346.6,470.9z M1849.3,856.2h-154.1L1661,1036h-162.7l137-693.5h316.8c137,8.6,205.5,77.1,205.5,196.9 C2157.5,744.9,1994.9,864.7,1849.3,856.2z"
}));

function SvgPhp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 1309",
    style: {
      enableBackground: "new 0 0 2500 1309"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/php.728887e1.svg";
export { ForwardRef as ReactComponent };